"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _Checkbox = _interopRequireDefault(require("@micado-digital/react-form/Checkbox"));
var _Option = _interopRequireDefault(require("./Option.styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Option = _ref => {
  let {
    checked = false,
    count = 0,
    id,
    identifier,
    showCount = true,
    title,
    CheckboxProps,
    onChange
  } = _ref;
  const css = (0, _Option.default)();
  const label = (0, _react.useMemo)(() => {
    return `<span class="label">${title}</span>${showCount ? `<span class="count">(${count})</span>` : ``} `;
  }, [count, showCount, title]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.option, "mco-filter-item__option"),
    key: `${identifier}-${id}`
  }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
    checked: checked,
    key: id,
    label: label,
    name: identifier,
    setChecked: e => onChange && onChange(identifier, id),
    value: id,
    CheckboxProps: {
      classes: {
        root: (0, _clsx.default)(css.checkbox, "mco-filter-item__option-checkbox")
      },
      disabled: showCount && count === 0,
      ...CheckboxProps
    },
    FormControlProps: {
      classes: {
        root: (0, _clsx.default)(css.formControlRoot, "mco-filter-item__option-form-control")
      }
    },
    FormControlLabelProps: {
      classes: {
        root: (0, _clsx.default)(css.formControlLabelRoot, "mco-filter-item__option-form-control-root"),
        label: (0, _clsx.default)(css.formControlLabel, "mco-filter-item__option-form-control-label")
      }
    }
  }));
};
var _default = exports.default = Option;